import { render, staticRenderFns } from "./PersonalRegisteration.vue?vue&type=template&id=1f3c9818&scoped=true&"
import script from "./PersonalRegisteration.vue?vue&type=script&lang=js&"
export * from "./PersonalRegisteration.vue?vue&type=script&lang=js&"
import style0 from "./PersonalRegisteration.vue?vue&type=style&index=0&id=1f3c9818&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3c9818",
  null
  
)

export default component.exports